<template>
  <div class="investment-admin">
    <el-button type="primary" @click="openDialog()">新增图片</el-button>
    <el-button type="success" @click="openPptxDialog()" style="margin-left:10px">上传PPT</el-button>

    <el-table border :data="tableData" v-loading="loading" style="width: 100%">
      <el-table-column prop="id" label="序号" width="80"></el-table-column>
      <el-table-column prop="imageUrl" label="图片预览">
        <template slot-scope="scope">
          <img style="width:300px" :src="scope.row.imageUrl" alt />
        </template>
      </el-table-column>
      <el-table-column prop="title" label="图片标题" width="180"></el-table-column>
      <el-table-column label="操作" width="240">
        <template slot-scope="scope">
          <el-button
            type="primary"
            icon="el-icon-edit"
            size="small"
            @click="handleEdit(scope.$index, scope.row)"
          >编辑</el-button>
          <el-button
            type="success"
            icon="el-icon-top"
            size="small"
            :disabled="scope.$index === 0"
            @click="moveUp(scope.$index)"
          >上移</el-button>
          <el-button
            type="warning"
            icon="el-icon-bottom"
            size="small"
            :disabled="scope.$index === tableData.length - 1"
            @click="moveDown(scope.$index)"
          >下移</el-button>
          <el-button
            type="danger"
            icon="el-icon-delete"
            size="small"
            @click="handleDelete(scope.$index, scope.row)"
          >删除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <el-dialog title="招商图片管理" :visible.sync="dialogFormVisible" width="520px">
      <el-form :model="formData">
        <el-form-item label="图片上传" :label-width="formLabelWidth">
          <div class="upload-area">
            <input
              type="file"
              accept="image/*"
              ref="fileInput"
              @change="onFileSelected"
              style="display:none"
            />
            <div v-if="formData.imageUrl" class="preview-wrap">
              <img :src="formData.imageUrl" class="preview-img" />
              <el-button size="small" type="text" @click="formData.imageUrl = ''; formData.file = null; $refs.fileInput.value = ''">
                重新选择
              </el-button>
            </div>
            <div v-else class="upload-placeholder" @click="$refs.fileInput.click()">
              <i class="el-icon-plus upload-icon"></i>
              <span>点击上传图片</span>
            </div>
          </div>
          <p v-if="uploading" style="color:#409eff;margin-top:6px">上传中...</p>
        </el-form-item>
        <el-form-item label="图片标题" :label-width="formLabelWidth">
          <el-input v-model="formData.title" autocomplete="off" placeholder="可选，用于图片底部说明"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="handleSave()" :loading="saving">确 定</el-button>
      </div>
    </el-dialog>

    <el-dialog title="上传PPT" :visible.sync="pptxDialogVisible" width="450px">
      <div style="text-align:center">
        <input
          type="file"
          accept=".pptx"
          ref="pptxInput"
          @change="onPptxFileSelected"
          style="display:none"
        />
        <el-button type="primary" size="medium" @click="$refs.pptxInput.click()" :disabled="pptxUploading">
          {{ pptxForm.fileName ? '重新选择' : '选择 PPTX 文件' }}
        </el-button>
        <p v-if="pptxForm.fileName" style="margin-top:12px;color:#606266">
          已选择：{{ pptxForm.fileName }}
        </p>
        <p v-if="pptxUploading" style="color:#409eff;margin-top:6px">
          <i class="el-icon-loading"></i> 正在转换幻灯片，请稍候...
        </p>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="pptxDialogVisible = false" :disabled="pptxUploading">取 消</el-button>
        <el-button type="primary" @click="handlePptxUpload()" :loading="pptxUploading" :disabled="!pptxForm.file">
          开始转换
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      loading: true,
      saving: false,
      uploading: false,
      dialogFormVisible: false,
      formLabelWidth: '100px',
      tableData: [],
      formData: {
        id: '',
        imageUrl: '',
        title: '',
        file: null
      },
      pptxDialogVisible: false,
      pptxUploading: false,
      pptxForm: { file: null, fileName: '' }
    };
  },
  mounted() {
    this.loadData();
  },
  methods: {
    getAuthHeaders() {
      const token = sessionStorage.getItem('token');
      return {
        'Content-Type': 'application/json',
        'Authorization': token
      };
    },
    async loadData() {
      this.loading = true;
      try {
        const res = await fetch('/api/investment');
        if (!res.ok) throw new Error('加载失败');
        this.tableData = await res.json();
      } catch (e) {
        this.$message({ message: '加载失败：' + e.message, type: 'error' });
      } finally {
        this.loading = false;
      }
    },
    openDialog() {
      this.formData = { id: '', imageUrl: '', title: '', file: null };
      if (this.$refs.fileInput) this.$refs.fileInput.value = '';
      this.dialogFormVisible = true;
    },
    handleEdit(index, row) {
      this.formData = { id: row.id, imageUrl: row.imageUrl, title: row.title, file: null };
      if (this.$refs.fileInput) this.$refs.fileInput.value = '';
      this.dialogFormVisible = true;
    },
    onFileSelected(e) {
      const file = e.target.files[0];
      if (!file) return;
      this.formData.file = file;
    },
    async uploadImage(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = () => resolve(reader.result);
        reader.onerror = () => reject(new Error('读取图片失败'));
        reader.readAsDataURL(file);
      }).then(dataUrl =>
        fetch('/api/upload-image', {
          method: 'POST',
          headers: this.getAuthHeaders(),
          body: JSON.stringify({ fileName: file.name, dataUrl })
        }).then(async res => {
          if (!res.ok) {
            const err = await res.json().catch(() => ({}));
            throw new Error(err.message || '上传失败');
          }
          const result = await res.json();
          return result.url;
        })
      );
    },
    async handleSave() {
      const { id, title, file } = this.formData;
      let imageUrl = this.formData.imageUrl;

      if (file) {
        this.uploading = true;
        try {
          imageUrl = await this.uploadImage(file);
          this.uploading = false;
        } catch (e) {
          this.uploading = false;
          this.$message({ message: '上传失败：' + e.message, type: 'error' });
          return;
        }
      }

      if (!imageUrl) {
        this.$message({ message: '请选择图片', type: 'warning' });
        return;
      }

      this.saving = true;
      try {
        const method = id ? 'PUT' : 'POST';
        const body = id ? { id, imageUrl, title } : { imageUrl, title };
        const res = await fetch('/api/investment', {
          method,
          headers: this.getAuthHeaders(),
          body: JSON.stringify(body)
        });
        if (!res.ok) {
          const err = await res.json().catch(() => ({}));
          throw new Error(err.message || '保存失败');
        }
        this.$message({ message: id ? '修改成功！' : '添加成功！', type: 'success' });
        this.dialogFormVisible = false;
        this.loadData();
      } catch (e) {
        this.$message({ message: '保存失败：' + e.message, type: 'error' });
      } finally {
        this.saving = false;
      }
    },
    handleDelete(index, row) {
      this.$confirm('此操作将永久删除此图片, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(async () => {
          try {
            const res = await fetch(`/api/investment?id=${row.id}`, {
              method: 'DELETE',
              headers: this.getAuthHeaders()
            });
            if (!res.ok) throw new Error('删除失败');
            this.$message({ message: '删除成功！', type: 'success' });
            this.loadData();
          } catch (e) {
            this.$message({ message: '删除失败：' + e.message, type: 'error' });
          }
        })
        .catch(() => {
          this.$message({ type: 'info', message: '已取消删除' });
        });
    },
    async moveUp(index) {
      if (index === 0) return;
      const arr = [...this.tableData];
      const temp = arr[index];
      arr[index] = arr[index - 1];
      arr[index - 1] = temp;
      await this.saveOrder(arr);
    },
    async moveDown(index) {
      if (index >= this.tableData.length - 1) return;
      const arr = [...this.tableData];
      const temp = arr[index];
      arr[index] = arr[index + 1];
      arr[index + 1] = temp;
      await this.saveOrder(arr);
    },
    async saveOrder(images) {
      try {
        const res = await fetch('/api/investment', {
          method: 'PUT',
          headers: this.getAuthHeaders(),
          body: JSON.stringify({ images })
        });
        if (!res.ok) throw new Error('排序失败');
        this.tableData = images;
      } catch (e) {
        this.$message({ message: '排序失败：' + e.message, type: 'error' });
      }
    },
    openPptxDialog() {
      this.pptxForm = { file: null, fileName: '' };
      if (this.$refs.pptxInput) this.$refs.pptxInput.value = '';
      this.pptxDialogVisible = true;
    },
    onPptxFileSelected(e) {
      const file = e.target.files[0];
      if (!file) return;
      this.pptxForm.file = file;
      this.pptxForm.fileName = file.name;
    },
    async handlePptxUpload() {
      const file = this.pptxForm.file;
      if (!file) {
        this.$message({ message: '请先选择 PPTX 文件', type: 'warning' });
        return;
      }

      this.pptxUploading = true;
      try {
        const dataUrl = await new Promise((resolve, reject) => {
          const reader = new FileReader();
          reader.onload = () => resolve(reader.result);
          reader.onerror = () => reject(new Error('读取文件失败'));
          reader.readAsDataURL(file);
        });

        const res = await fetch('/api/investment/upload-pptx', {
          method: 'POST',
          headers: this.getAuthHeaders(),
          body: JSON.stringify({ fileName: file.name, dataUrl })
        });

        if (!res.ok) {
          const err = await res.json().catch(() => ({}));
          throw new Error(err.message || '转换失败');
        }

        const result = await res.json();
        this.$message({ message: result.message || `已导入 ${result.images ? result.images.length : 0} 张幻灯片`, type: 'success' });
        this.pptxDialogVisible = false;
        this.loadData();
      } catch (e) {
        this.$message({ message: '转换失败：' + e.message, type: 'error' });
      } finally {
        this.pptxUploading = false;
      }
    }
  }
};
</script>

<style scoped>
.el-table {
  margin-top: 20px;
}

.upload-area {
  width: 100%;
}

.upload-placeholder {
  width: 300px;
  height: 180px;
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  color: #8c939d;
  transition: border-color 0.3s;
}

.upload-placeholder:hover {
  border-color: #409eff;
}

.upload-icon {
  font-size: 28px;
  margin-bottom: 8px;
}

.preview-wrap {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
}

.preview-img {
  width: 300px;
  height: 180px;
  object-fit: cover;
  border-radius: 6px;
  border: 1px solid #eee;
}
</style>
